import { render, staticRenderFns } from "./modalAddCompanyMember.vue?vue&type=template&id=c5b4ad7e&"
import script from "./modalAddCompanyMember.vue?vue&type=script&lang=js&"
export * from "./modalAddCompanyMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports